/** Statuses that fully lock the clinic workspace until the platform resolves them out-of-band. */
export function isSubscriptionLocked(status: string | undefined): boolean {
  return status === 'PendingPayment';
}
